import React, { useState } from "react";
import { MapPin, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { updateProfile, formatApiError } from "@/lib/api";

const KEY = (uid) => `vb_pin_prompt_snooze_${uid}`;
const SNOOZE_MS = 7 * 86400000;

// Older accounts without a saved PIN: non-blocking, dismissible request to add one.
export default function MissingPinPrompt() {
  const { user, refreshUser, pincode } = useApp();
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [hidden, setHidden] = useState(false);
  // Shown once a browsing PIN exists, so it does not stack with the PIN-picker/location banners.
  if (!user || !pincode || hidden || /^\d{6}$/.test(user.pincode || "")) return null;
  if (Number(localStorage.getItem(KEY(user.id)) || 0) > Date.now()) return null;
  const valid = /^[1-9]\d{5}$/.test(pin);
  const dismiss = () => { try { localStorage.setItem(KEY(user.id), String(Date.now() + SNOOZE_MS)); } catch { /* storage blocked: snooze lasts this session only */ } setHidden(true); };
  const save = async (e) => {
    e.preventDefault();
    if (!valid) { toast.error("Sahi 6-digit PIN code daalein."); return; }
    setBusy(true);
    try { await updateProfile({ pincode: pin }); await refreshUser(); toast.success("PIN code save ho gaya"); }
    catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 mt-3" data-testid="missing-pin-prompt">
      <form onSubmit={save} className="flex flex-wrap items-center gap-2 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3">
        <MapPin className="w-4 h-4 text-amber-700 flex-shrink-0" />
        <span className="text-sm text-amber-900 flex-1 min-w-[12rem]">Apna PIN code jodein — isse aapke area ki listings aasani se dikhengi.</span>
        <input value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))} inputMode="numeric" maxLength={6} placeholder="6-digit PIN"
          className="w-32 rounded-full border border-amber-300 bg-white px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500" data-testid="missing-pin-input" />
        <button type="submit" disabled={busy || !valid} className="rounded-full bg-emerald-700 hover:bg-emerald-800 active:bg-emerald-900 text-white px-4 py-1.5 text-sm font-semibold disabled:opacity-50 min-h-[36px]" data-testid="missing-pin-save">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save"}
        </button>
        <button type="button" onClick={dismiss} className="p-1.5 text-amber-700 hover:text-amber-900" aria-label="Baad mein" data-testid="missing-pin-dismiss"><X className="w-4 h-4" /></button>
      </form>
    </div>
  );
}
